import {
	ENTITIES_ADD,
	ENTITIES_MUTATE,
	ENTITIES_REMOVE,
	ENTITIES_REPLACE,
} from '../constants/actionTypes';

import { isArray, merge, omit } from 'lodash';

const initialState = {
	adminNotifications: {},
	bulletins: {},
	bulletinTags: {},
	CRs: {},
	CRSummaries: {},
	endUsers: {},
	endUserSerialNumbers: {},
	oems: {},
	folders: {},
	groups: {},
	pages: {},
	pageFiles: {},
	PISheets: {},
	PICategories: {},
	products: {},
	QSRCategories: {},
	QSRItems: {},
	QSRManufacturers: {},
	QSRs: {},
	sourcesafeEntries: {},
	timezones: {},
	users: {},
};

export default function entities(state = initialState, action) {
	switch (action.type) {
		case ENTITIES_ADD:
			return merge({}, state, action.payload);

		/**
		 * Kind of confusing, but I will try to explain
		 */
		case ENTITIES_MUTATE:
			const { key, id, attribute, fn } = action.payload;

			// Entity is the single entity from the state based on key and id parameters
			const entity = state[key][id];

			// If the entitiy is not in the store, return the current state
			if (!entity) return state;

			// Apply the function to the attribute in the entity
			const mutatedAttribute = fn(entity[attribute]);

			// Return new state, replacing the attribute
			// only on the entity requested to be mutated
			return {
				...state,
				[key]: {
					...state[key],
					[id]: {
						...state[key][id],
						[attribute]: mutatedAttribute,
					},
				},
			};

		case ENTITIES_REPLACE:
			return {
				...state,
				...action.payload,
			};

		case ENTITIES_REMOVE:
			const { type, ids } = action.payload;

			if (isArray(ids)) {
				const copyOfState = { ...state };

				ids.forEach(id => delete copyOfState[type][id]);

				return { ...copyOfState };
			}

			const omitKey = `${type}.${ids}`;

			return omit(state, omitKey);

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/entities.js